const SUPPORT_MAIN_COLOR = '#54AD7A';

const defualtTheme = {
  overrides: {
    MuiInputBase: {
      input: {
        backgroundColor: 'white',
      },
    },
    MuiButton: {
      root: {
        borderRadius: 0,
      },
      contained: {
        boxShadow: 'none',
      },
    },
    MuiRadio: {
      colorSecondary: {
        '&$checked': {
          color: SUPPORT_MAIN_COLOR,
        },
      },
    },
    MuiCheckbox: {
      colorSecondary: {
        color: 'grey',
        '&$checked': {
          color: 'black',
        },
      },
    },
    MuiDialog: {
      paper: {
        overflowY: 'visible',
      },
    },
  },
  palette: {
    primary: {
      main: '#eac13e',
    },
    secondary: {
      main: '#ef6c00',
    },
    support: {
      main: SUPPORT_MAIN_COLOR,
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 796,
      md: false,
      lg: false,
      xl: false,
    },
  },
};

export default defualtTheme;
